'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _pathToRegexp = require('path-to-regexp');

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

var _reactRouterDom = require('react-router-dom');

var _lodash = require('lodash');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var has = Object.prototype.hasOwnProperty;
var routes = {};

/**
 * Route translation from name to path
 */

var RouteCollection = function () {
  function RouteCollection() {
    (0, _classCallCheck3.default)(this, RouteCollection);
  }

  (0, _createClass3.default)(RouteCollection, null, [{
    key: 'addRoute',


    /**
     * Add named route to collection
     *
     * @param {string} name Route name
     * @param {string} path `path-to-regexp` compatible path
     * @public
     */
    value: function addRoute(name, routeProps) {
      var path = routeProps.path;

      if (name === undefined) {
        return;
      } else if (!has.call(routes, name)) {
        routes[name] = [];
      }

      var keys = [];
      (0, _pathToRegexp2.default)(path, keys);
      keys = (0, _lodash.keyBy)(keys, 'name');

      var exists = routes[name].reduce(function (found, route) {
        return found || (0, _lodash.isEqual)({ name: route.name, path: route.path }, { name: routeProps.name, path: routeProps.path });
      }, false);

      if (!exists) {
        routes[name].push((0, _extends3.default)({}, routeProps, { keys: keys }));
        routes[name] = (0, _lodash.orderBy)(routes[name], function (route) {
          return (0, _keys2.default)(route.keys).length;
        });
      }
    }

    /**
     * Get list of routes
     * @return {object} Name => Array<route>
     */

  }, {
    key: 'getRoutes',
    value: function getRoutes() {
      return routes;
    }

    /**
     * Applies parameters to a named route
     *
     * @throws {PathNotFound} when there is no path by that name
     *
     * @param  {string} name   The name of the path
     * @param  {object} params The parameters to be applied by their name in the path
     * @public
     *
     * @return {[type]}        [description]
     */

  }, {
    key: 'getPath',
    value: function getPath(name, params) {
      var routesByName = routes[name];
      var paramKeys = ((typeof params === 'undefined' ? 'undefined' : (0, _typeof3.default)(params)) === 'object' ? (0, _keys2.default)(params) : []).filter(function (key) {
        return params[key];
      });

      if (routesByName === undefined) {
        throw new Error('PathNotFound', name, params);
      }

      var bestMatch = routesByName.length === 1 ? { route: routesByName[0] } : routesByName.reduce(function (result, route) {
        var routeKeys = (0, _keys2.default)(route.keys);
        var commonKeys = (0, _lodash.intersection)(paramKeys, routeKeys);
        if (result === undefined && commonKeys.length !== 0 || result === undefined && routeKeys.length === 0 || result !== undefined && commonKeys.length > result.matched) {
          return {
            matched: commonKeys.length,
            route: route
          };
        }
        return result;
      }, undefined);

      if (bestMatch === undefined) {
        throw new Error('PathNotFound', name, params);
      }

      var toPath = _pathToRegexp2.default.compile(bestMatch.route.path);

      return toPath(RouteCollection.processParams(params));
    }

    /**
     * Slugify param values if an object is given
     *
     * @param  {object} params
     * @return {object}        params with values slugified and lowercased
     */

  }, {
    key: 'processParams',
    value: function processParams(params) {
      if ((typeof params === 'undefined' ? 'undefined' : (0, _typeof3.default)(params)) !== 'object') {
        return params;
      }
      var SlugifiedParams = {};
      (0, _keys2.default)(params).forEach(function (key) {
        var param = params[key];

        if (typeof param !== 'string') {
          param = String(param);
        }

        SlugifiedParams[key] = (0, _bdcoreUtilities.Slugify)(param.toLowerCase());
      });

      return SlugifiedParams;
    }

    /**
     * Checks if any named routes are loaded
     *
     * @public
     *
     * @return {Boolean}
     */

  }, {
    key: 'hasRoutes',
    value: function hasRoutes() {
      return (0, _keys2.default)(routes).length > 0;
    }

    /**
     * Checks if the given route is set
     *
     * @param {string} route name to find
     * @public
     *
     * @return {Boolean}
     */

  }, {
    key: 'hasRoute',
    value: function hasRoute(name) {
      return (0, _keys2.default)(routes).indexOf(name) !== -1;
    }
  }, {
    key: 'getRouteByPath',
    value: function getRouteByPath(path) {
      var paths = (0, _keys2.default)(routes).reduce(function (result, key) {
        result.push.apply(result, (0, _toConsumableArray3.default)(routes[key]));
        return result;
      }, []);

      var match = paths.find(function (route) {
        return (0, _reactRouterDom.matchPath)(path, route);
      });
      var params = {};
      if (match) {
        var toPath = (0, _pathToRegexp2.default)(match.path);
        var result = toPath.exec(path);
        (0, _keys2.default)(match.keys).forEach(function (key, index) {
          params[key] = result[index + 1];
        });
      }

      return (0, _extends3.default)({}, match, { params: params, url: path });
    }
  }]);
  return RouteCollection;
}();

exports.default = RouteCollection;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-named-routes/build/RouteCollection.js
// module id = 251
// module chunks = 0